import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84fd4828"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-mobile-media-slider" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "frisbuy-mobile-media-slider__play-icon"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-84fd4828><circle cx=\"24\" cy=\"24\" r=\"16\" fill=\"#212121\" fill-opacity=\"0.2\" data-v-84fd4828></circle><g opacity=\"0.8\" data-v-84fd4828><path d=\"M28.1192 22.7772C28.8701 23.2446 28.8701 24.4239 28.1192 24.8912L22.6451 28.2979C21.8999 28.7616 20.9727 28.1756 20.9727 27.2409L20.9727 20.4276C20.9727 19.4928 21.8999 18.9068 22.6451 19.3706L28.1192 22.7772Z\" fill=\"white\" data-v-84fd4828></path><path d=\"M34.125 24.0005C34.125 18.4083 29.5921 13.8744 24 13.8742C18.4076 13.8742 13.8737 18.4081 13.8737 24.0005C13.8739 29.5926 18.4078 34.1255 24 34.1255C29.592 34.1252 34.1248 29.5925 34.125 24.0005ZM36.7917 24.0005C36.7914 31.0652 31.0647 36.7919 24 36.7922C16.935 36.7922 11.2073 31.0654 11.207 24.0005C11.207 16.9354 16.9349 11.2075 24 11.2075C31.0649 11.2078 36.7917 16.9355 36.7917 24.0005Z\" fill=\"white\" data-v-84fd4828></path></g></svg>", 1)
const _hoisted_6 = [
  _hoisted_5
]

import { nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import widgetTypes from "@/common/consts/widgetTypes";
import { imageWithPostId } from "../interfaces";

type JQ = ((...args: any[]) => any) & { fn?: Record<string, any> };

declare global {
  interface Window {
    jQuery?: JQ;
    $?: JQ;
  }
}

const PRELOAD_MEDIA_BEFORE_END = 2;
const SCROLL_END_THRESHOLD_PX = 8;

export default /*#__PURE__*/_defineComponent({
  __name: 'PopupReviewMobileMediaSlider',
  props: {
    mediaList: {},
    selectedMediaThumbnailUrl: {}
  },
  emits: ["selectMedia", "requestToLoadCustomersMedia"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const track = ref<HTMLElement | null>(null);
const fotoramaHost = ref<HTMLElement | null>(null);
const didRequestAtScrollEnd = ref(false);

function errorImageHandler(e: Event) {
  MediaCatcher(e, 2, widgetTypes.STORY);
}

function ensureStylesheet(href: string) {
  if (document.querySelector(`link[href="${href}"]`)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}

function ensureScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });
}

async function initFotoramaCdn() {
  try {
    ensureStylesheet("https://cdnjs.cloudflare.com/ajax/libs/fotorama/4.6.4/fotorama.css");
    await ensureScript("https://code.jquery.com/jquery-3.7.1.min.js");
    await ensureScript("https://cdnjs.cloudflare.com/ajax/libs/fotorama/4.6.4/fotorama.min.js");

    const $ = window.jQuery || window.$;
    if (!$ || !$.fn?.fotorama || !fotoramaHost.value) {
      return;
    }

    // Minimal hidden init so CDN dependency is bound to the component lifecycle.
    fotoramaHost.value.innerHTML = '<div class="fotorama" data-width="1" data-height="1" data-nav="false"></div>';
    $(fotoramaHost.value.querySelector('.fotorama')).fotorama();
  } catch (e) {
    // Soft-fail: slider keeps working with native touch scroll.
  }
}

function centerSelectedThumb() {
  if (!track.value || !props.selectedMediaThumbnailUrl) return;

  const selectedIndex = props.mediaList.findIndex(
    (media) => media.thumbnailUrl === props.selectedMediaThumbnailUrl
  );

  if (selectedIndex < 3) {
    track.value.scrollTo({
      left: 0,
      behavior: "smooth",
    });
    return;
  }

  const selectedEl = track.value.children[selectedIndex] as HTMLElement | undefined;
  if (!selectedEl) return;
  selectedEl.scrollIntoView({
    behavior: "smooth",
    inline: "center",
    block: "nearest",
  });
}

function requestToLoadCustomersMedia() {
  emit("requestToLoadCustomersMedia");
}

function shouldPreloadBySelectedMedia() {
  if (!props.selectedMediaThumbnailUrl || props.mediaList.length === 0) {
    return false;
  }

  const selectedIndex = props.mediaList.findIndex(
    (media) => media.thumbnailUrl === props.selectedMediaThumbnailUrl
  );

  if (selectedIndex < 0) {
    return false;
  }

  return selectedIndex >= props.mediaList.length - 1 - PRELOAD_MEDIA_BEFORE_END;
}

function checkNeedLoadBySelectedMedia() {
  if (shouldPreloadBySelectedMedia()) {
    requestToLoadCustomersMedia();
  }
}

function isTrackScrolledToEnd() {
  if (!track.value) {
    return false;
  }

  return (
    track.value.scrollLeft + track.value.clientWidth >=
    track.value.scrollWidth - SCROLL_END_THRESHOLD_PX
  );
}

function onTrackScroll() {
  const isAtEnd = isTrackScrolledToEnd();

  if (isAtEnd && !didRequestAtScrollEnd.value) {
    didRequestAtScrollEnd.value = true;
    requestToLoadCustomersMedia();
    return;
  }

  if (!isAtEnd) {
    didRequestAtScrollEnd.value = false;
  }
}

onMounted(async () => {
  await initFotoramaCdn();
  nextTick(centerSelectedThumb);
  track.value?.addEventListener("scroll", onTrackScroll, { passive: true });
  checkNeedLoadBySelectedMedia();
});

onBeforeUnmount(() => {
  track.value?.removeEventListener("scroll", onTrackScroll);
});

watch(
  () => props.selectedMediaThumbnailUrl,
  () => {
    nextTick(centerSelectedThumb);
    checkNeedLoadBySelectedMedia();
  }
);

watch(
  () => props.mediaList,
  () => {
    checkNeedLoadBySelectedMedia();
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "track",
      ref: track,
      class: "frisbuy-mobile-media-slider__track"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.mediaList, (media, idx) => {
        return (_openBlock(), _createElementBlock("button", {
          key: idx,
          type: "button",
          class: _normalizeClass(["frisbuy-mobile-media-slider__item", {
          'frisbuy-mobile-media-slider__item--selected':
            props.selectedMediaThumbnailUrl &&
            media.thumbnailUrl === props.selectedMediaThumbnailUrl,
        }]),
          onClick: ($event: any) => (emit('selectMedia', media))
        }, [
          _createElementVNode("img", {
            class: "frisbuy-mobile-media-slider__image",
            src: _unref(DomainSubstitute)(media.thumbnailUrl),
            onError: errorImageHandler
          }, null, 40, _hoisted_3),
          (media.videoUrl.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      }), 128))
    ], 512),
    _createElementVNode("div", {
      ref_key: "fotoramaHost",
      ref: fotoramaHost,
      class: "frisbuy-mobile-media-slider__fotorama-host",
      "aria-hidden": "true"
    }, null, 512)
  ]))
}
}

})